import React from 'react';
import NameCellWrapper from '@/components/table/NameCellWrapper';
import TokenIcon from './TokenIcon';

const TokenNameCell = ({ active, jwt, name }) => (
  <NameCellWrapper name={name} className="aridhia-token-name-cell">
    <TokenIcon active={active} jwt={jwt} />
    {name}
  </NameCellWrapper>
);

export default TokenNameCell;
